export const nodeParagraphShouldNotContainTable = (node) => {
  if (node && node.type === 'p' && node?.children?.[0] === 'table') {
    return node.children[0];
  }

  return node;
};
